import React, { useState } from 'react'
import { Container, Titulo, BoxItensInclusos, BoxItensInclusosTitulo, BoxItensInclusosLista, BoxItensInclusosListaItem, BoxItensInclusosListaImg, BoxItensInclusosListTitulo, BoxItensInclusosListBoxInfo, BoxItensInclusosListBoxInfoIcone, BoxItensInclusosListBoxInfoModalInfo, BoxItensInclusosListBoxInfoModalIcFechar, BoxItensInclusosListBoxInfoModalIcFecharImg, BoxItensInclusosListBoxInfoDescricao, BoxItensInclusosListBoxInfoButtonVideo, BoxItensInclusosListBoxInfoButtonVideoTexto, BoxItensInclusosListBoxInfoButtonVideoImg, ModalVideo, ModalVideoFlex, ModalVideoFlexBoxVideoBotaofechar, ModalVideoFlexBoxVideoBotaofecharImg, ModalVideoFlexBoxVideoIframe, ModalVideoFlexBoxVideo, BoxItensInclusosListaAssinaturas, BoxItensInclusosListaAssinaturasCard, BoxItensInclusosListaAssinaturasCardTitulo, BoxItensInclusosListaAssinaturasCardDescricao, BoxItensInclusosListaAssinaturasCardPrecoDe, BoxItensInclusosListaAssinaturasCardPrecoPor, BoxItensInclusosListaAssinaturasCardLink, TagEconomize } from './Styled'
import icCheck from 'images/promocao-cge-sp-2025/ic-check.png'
import icInfo from 'images/promocao-cge-sp-2025/ic-info.png'
import icFechaModal from 'images/promocao-cge-sp-2025/ic-close-modal.svg'
import icPlay from 'images/promocao-cge-sp-2025/ic-play.svg'
import { toMoney } from 'utils/helpers'

export default function ItensInclusos ({ planos, desconto, porcentagem }) {	

	const [modalVideo, SetModalVideo] = useState({
		url: "",
		open: false
	})
	
	const [lista, setLista] = useState([
		{
			"titulo": "Acesso ilimitado a todos os pacotes de concursos do site.",
			"descricao": "",
			"video": "",
			"open": false
		},	
		{
			"titulo": "Livro Digital Interativo para um estudo dinâmico e mais conectado",
			"descricao": "",
			"video": "",
			"open": false
		},
		{
			"titulo": "100 mil videoaulas com professores renomados",
			"descricao": "",
			"video": "",
			"open": false
		},
		{
			"titulo": "Sistema de Questões",
			"descricao": "O maior Sistema de Questões! Acesse e se prepare com mais de 3,2 milhões de questões de concursos cadastradas. Estude sem limites no seu tempo e seja aprovado.",
			"video": "",
			"open": false
		},
		{
			"titulo": "Cast Concursos",
			"descricao": "Estude sempre que quiser pelo app, com mais de 10 mil aulas em áudio para concursos em vários formatos: completos, de Reta Final, focados em editais específicos e de legislação.",
			"video": "https://www.youtube.com/embed/10VASiDPoFU",
			"open": false
		},
		{
			"titulo": "Livro Digital Simplificado",
			"descricao": "PDF com conteúdo mais enxuto, indo direto ao que realmente importa para acertar questões, sem ser superficial",
			"video": "https://www.youtube.com/embed/PNiPFTAgDuY",
			"open": false
		},
		{
			"titulo": "Monitor de Performance",
			"descricao": "Você acompanha sua evolução de quantidade de questões resolvidas no Sistema de Questões, tanto por período quanto por matéria, além do percentual médio de acertos. Você também poderá acompanhar o percentual médio de acertos de outros alunos por matéria.",
			"video": "https://www.youtube.com/embed/0L0hl2vBCOo",
			"open": false
		},
		{
			"titulo": "Cursos Especiais (Exclusivos)",
			"descricao": "Cursos especiais exclusivos para assinantes.",
			"video": "https://www.youtube.com/embed/CxZ5SiAevZA",
			"open": false
		},
		{
			"titulo": "Resumos",
			"descricao": "Poupe o seu tempo utilizando os resumos completos elaborados por nossos professores. Além disso, você tem os Bizus, que são resumos bem mais enxutos (30 páginas por disciplina), para serem utilizados geralmente no pós-edital, e que são elaborados por nossos ex-alunos já aprovados nos concursos mais difíceis do país.",
			"video": "https://www.youtube.com/embed/YR-1DeO6L1w",
			"open": false
		},
		{
			"titulo": "Marcação dos Aprovados",
			"descricao": "PDF com as partes mais importantes já marcadas por aprovados em concursos.",
			"video": "https://www.youtube.com/embed/bvuJqIgFGYw",
			"open": false
		},
		{
			"titulo": "Mapas Mentais",
			"descricao": "Quer entender a matéria de uma maneira bastante visual? Use os nossos mapas mentais, que utilizam diversos esquemas gráficos para te ajudar na compreensão total da matéria.",
			"video": "https://www.youtube.com/embed/dYEK1GrWPFM",
			"open": false
		},
		{
			"titulo": "Trilha Estratégica",
			"descricao": "Sucesso entre nossos alunos, a Trilha é um planejamento completo, dividido em tarefas, que lhe dizem exatamente o que estudar, quais questões resolver e o que revisar, apontando quais assuntos possuem maior ou menor chance de aparecerem em prova.",
			"video": "https://www.youtube.com/embed/UClxw-cAVqk",
			"open": false
		},
		{
			"titulo": "Passo Estratégico",
			"descricao": "O Passo Estratégico complementa seus estudos com uma abordagem sucinta e priorizando os assuntos mais cobrados dos últimos concursos, além de simulados inéditos no estilo da banca. Ele otimiza o tempo de estudo e ajuda na memorização dos principais temas.",
			"video": "https://www.youtube.com/embed/ZMCQTgsqFy0",
			"open": false
		},
		{
			"titulo": "Monitorias",
			"descricao": "A Monitoria oferece um direcionamento e acompanhamento aos alunos através de técnicas de estudo, sugestão de planejamento de estudos e motivação através de transmissões ao vivo.",
			"video": "https://www.youtube.com/embed/PYpuK9FbI-k",
			"open": false
		},
		{
			"titulo": "Salas VIP",
			"descricao": "Já pensou em falar com um aprovado ao vivo, por videoconferência? Essa é a nossa Sala VIP! Você cara a cara com um aprovado para tirar todas as suas dúvidas.",
			"video": "https://www.youtube.com/embed/Emw3TkMLH5c",
			"open": false
		},
		{
			"titulo": "Rodadas Avançadas de Simulados",
			"descricao": "Já imaginou ter diversos simulados para você treinar para a prova? Com as Rodadas Avançadas, nossos professores elaboram questões inéditas de acordo com o perfil da sua banca para você simular o dia da prova.",
			"video": "https://www.youtube.com/embed/ZC-9ADhOIfw",
			"open": false
		}
	]);

	const showModal = (posicao) => {
		setLista(lista.map((modal, index) =>
			index === posicao ? { ...modal, open: true } : { ...modal, open: false }
		));
	};

	const hideModal = (posicao) => {
		setLista(lista.map((modal, index) =>
			index === posicao ? { ...modal, open: false } : modal
		));
	};

	const showModalVideo = (urlVideo) => {
		SetModalVideo({ url: urlVideo, open: true })
	};

	const hideModalVideo = () => {

		setLista(lista.map((modal) =>
			modal ? { ...modal, open: false } : modal
		));

		SetModalVideo({ url: "", open: false })

	};

	return (
		<Container>

			{/* Título */}
			<Titulo>Assine hoje com até<br /> <strong>40% de desconto</strong> e transforme cada edital em uma oportunidade!</Titulo>
			
			{/* Box Itens Inclusos */}
			<BoxItensInclusos>

				{/* Título */}
				<BoxItensInclusosTitulo>Premium</BoxItensInclusosTitulo>

				{/* Lista */}
				<BoxItensInclusosLista>

					{ lista.map((item, index) => {
						return (
							<BoxItensInclusosListaItem key={index}>

								{/* Imagem */}
								<BoxItensInclusosListaImg src={icCheck} />

								{/* Título */}
								<BoxItensInclusosListTitulo>{item.titulo}</BoxItensInclusosListTitulo>

								{/* Box Info */}
								{ item.descricao ?
								<BoxItensInclusosListBoxInfo>

									{/* Ícone */}
									<BoxItensInclusosListBoxInfoIcone src={icInfo} onClick={() => showModal(index)} />

									{/* Modal */}
									<BoxItensInclusosListBoxInfoModalInfo className={ item.open ? 'active' : '' }>

										{/* Fecha Modal */}
										<BoxItensInclusosListBoxInfoModalIcFechar onClick={() => hideModal(index)}>
											<BoxItensInclusosListBoxInfoModalIcFecharImg src={icFechaModal} />
										</BoxItensInclusosListBoxInfoModalIcFechar>

										{/* Descrição */}
										<BoxItensInclusosListBoxInfoDescricao>{ item.descricao }</BoxItensInclusosListBoxInfoDescricao>

										{/* Link Vídeo */}
										{ item.video ?
										<BoxItensInclusosListBoxInfoButtonVideo onClick={() => showModalVideo(item.video)}>

											<BoxItensInclusosListBoxInfoButtonVideoTexto>Entenda</BoxItensInclusosListBoxInfoButtonVideoTexto>

											<BoxItensInclusosListBoxInfoButtonVideoImg src={icPlay} />

										</BoxItensInclusosListBoxInfoButtonVideo>
										: null }

									</BoxItensInclusosListBoxInfoModalInfo>

								</BoxItensInclusosListBoxInfo>
								: null }

							</BoxItensInclusosListaItem>
						);
					}) }

				</BoxItensInclusosLista>

				{/* Lista Assinaturas */}
				<BoxItensInclusosListaAssinaturas>

					{/* Cartão */}
					<BoxItensInclusosListaAssinaturasCard>

						{/* Título */}
						<BoxItensInclusosListaAssinaturasCardTitulo>Cartão</BoxItensInclusosListaAssinaturasCardTitulo>

						{/* Descrição */}
						<BoxItensInclusosListaAssinaturasCardDescricao></BoxItensInclusosListaAssinaturasCardDescricao>

						{/* Preço De */}
						<BoxItensInclusosListaAssinaturasCardPrecoDe>{ planos.cartao.preco_de } por</BoxItensInclusosListaAssinaturasCardPrecoDe>

						{/* Preço Por */}
						<BoxItensInclusosListaAssinaturasCardPrecoPor><small>12x</small> { planos.cartao.preco_por.split("por 12x ")[1] }</BoxItensInclusosListaAssinaturasCardPrecoPor>

						{/* Link */}
						<BoxItensInclusosListaAssinaturasCardLink href={ planos.cartao.link }>Assine agora</BoxItensInclusosListaAssinaturasCardLink>

					</BoxItensInclusosListaAssinaturasCard>

					{/* Boleto */}
					<BoxItensInclusosListaAssinaturasCard>

						{/* Título */}
						<BoxItensInclusosListaAssinaturasCardTitulo>Boleto ou Pix</BoxItensInclusosListaAssinaturasCardTitulo>

						{/* Descrição */}
						<BoxItensInclusosListaAssinaturasCardDescricao>+10% OFF</BoxItensInclusosListaAssinaturasCardDescricao>

						{/* Preço De */}
						<BoxItensInclusosListaAssinaturasCardPrecoDe>De { planos.boleto.preco_de } por</BoxItensInclusosListaAssinaturasCardPrecoDe>

						{/* Preço Por */}
						<BoxItensInclusosListaAssinaturasCardPrecoPor>{ planos.boleto.preco_por }</BoxItensInclusosListaAssinaturasCardPrecoPor>

						{/* Link */}
						<BoxItensInclusosListaAssinaturasCardLink href={ planos.boleto.link } segundo>Assine agora</BoxItensInclusosListaAssinaturasCardLink>

					</BoxItensInclusosListaAssinaturasCard>

				</BoxItensInclusosListaAssinaturas>

			</BoxItensInclusos>

			{/* Economize */}
			<TagEconomize>Economize até {toMoney(desconto)} ({porcentagem}% OFF)</TagEconomize>

			{/* Modal Vídeo */}
			<ModalVideo className={ modalVideo.open ? 'active' : '' }>
				<ModalVideoFlex>
					<ModalVideoFlexBoxVideo>

						{/* Botão Fechar */}
						<ModalVideoFlexBoxVideoBotaofechar onClick={() => hideModalVideo()}>
							<ModalVideoFlexBoxVideoBotaofecharImg src={icFechaModal} />
						</ModalVideoFlexBoxVideoBotaofechar>

						{/* Iframe */}
						<ModalVideoFlexBoxVideoIframe src={ modalVideo.url } frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen />

					</ModalVideoFlexBoxVideo>
				</ModalVideoFlex>
			</ModalVideo>

		</Container>
	)
	}
